import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductsService } from 'src/app/views/products/products/products.service';
import { UsersService } from 'src/app/views/settings/users/users.service';
import { CreatelicenseService } from 'src/app/views/settings/createlicense/createlicense.service';
import { LicensedurationsService } from 'src/app/views/settings/licensedurations/licensedurations.service';
import { ToastService } from '../../../toast.service';
import { BaseService } from '../../../base.service';
import { TestingToolkitService } from '../../../services/testing-toolkit.service';
@Component({
  selector: 'app-nfrlicense',
  templateUrl: './nfrlicense.component.html',
  styleUrl: './nfrlicense.component.scss'
})
export class NFRLicenseComponent {
  roleData: any;
  usersData: any;
  taskList: any = '';
  selectedRoleId: any;
  msg: any;
  ProductsData: any;
  D_Year: string;
  D_Month: string;
  D_Day: string;
  D_Date: any;
  E_Date: any;
  constructor(
    public ProductService: ProductsService,
    public UsersService: UsersService,
    public LicensedurationsService: LicensedurationsService,
    public ClientlicensesService: CreatelicenseService,
    private router: Router,
    private ToastService: ToastService,
    private baseService: BaseService,
    private testingToolkit: TestingToolkitService
  ) {
    // Use testing toolkit date if set, otherwise use current date
    const today = this.testingToolkit.getCurrentDate();
    this.D_Year = today.toLocaleDateString('en-US', { year: 'numeric' });
    this.D_Month = today.toLocaleDateString('en-US', { month: '2-digit' });
    this.D_Day = today.toLocaleDateString('en-US', { day: '2-digit' });
    this.D_Date =
      this.D_Year + '-' + this.D_Month + '-' + this.D_Day + 'T00:00:00.000Z';

    // const E_Date = new Date(this.D_Date);
    // E_Date.setMonth(E_Date.getMonth() + );
    // this.E_Date = E_Date.toLocaleDateString('en-US', { year: 'numeric' })+"-"+E_Date.toLocaleDateString('en-US', { month: '2-digit' })+"-"+E_Date.toLocaleDateString('en-US', { day: '2-digit'  })+"T23:59:59.000Z";
  }

  // toggleChildren(parentTask: TaskAssignedToRole) {
  //   const children = this.taskList.filter((task: { ParentMenuID: number; }) => task.ParentMenuID === parentTask.Id);
  //   const parentIsAllowed = parentTask.IS_ALLOWED;

  //   // Update IsActive property for the parent and its children
  //   parentTask.IS_ALLOWED = parentIsAllowed;
  //   children.forEach((child: { IS_ALLOWED: boolean; }) => child.IS_ALLOWED = parentIsAllowed);
  // }

  partnerpercentage: any = 0;
  serviceItemDiscount: any = 0;
  UserType = 6;
  Loading: boolean = false;
  UsersData: any;
  async GetUserData() {
    this.Loading = true;

    var body = {
      partner_Id: JSON.parse(
        localStorage.getItem('UserInfo')?.toString() || '{}'
      )?.partner_Id,
      userType_Id: this.UserType,
    };
    this.UsersService.getAllByUserTypeAndPartnerID(body).subscribe({
      next: (res: any) => {
        this.UsersData = res.data;
        console.log('UsersData');
        console.log(this.UsersData);
        this.Loading = false;
      },
      error: (error) => {
        console.error(error);
        this.Loading = false;
      },
    });
  }

  async GetProductList(cid: any) {
    if (this.totalPrice != 0) {
      this.totalPrice = 0;
    }
    this.clientID = cid;
    this.ProductService.getProducts().subscribe((response: any) => {
      this.ProductsData = response.data.filter(
        (product: any) => product?.isActive == true
      );
      this.taskList = '';
      console.log('ProductList');
      console.log(this.ProductsData);
    });
  }

  proId: any;
  IsAllowedCentral: boolean = false;
  DurationOption: any;
  IsProductSelected: boolean = false;
  async GetFeatureList(ProId: any) {
    this.durationoptionselected = false;
    if (this.totalPrice != 0) {
      this.totalPrice = 0;
    }
    if (ProId != 0) {
      this.IsProductSelected = true;
    } else {
      this.IsProductSelected = false;
    }
    this.LicensedurationsService.getAssignedLicensedurationsByProductId(
      ProId
    ).subscribe((response: any) => {
      this.DurationOption = response.data;

      console.log(this.DurationOption);
    });

    const pdata = this.ProductsData.find((product: { id: any }) => {
      return product.id == ProId;
    });

    if (pdata) {
      console.log(pdata.isCentralAllowed);
      this.IsAllowedCentral = pdata.isCentralAllowed;
    } else {
      console.log('Product with ID', ProId, 'not found.');
    }

    this.proId = ProId;

    this.ClientlicensesService.getTaskList(ProId).subscribe((response: any) => {
      this.taskList = response.data;
      console.log('===list====');
      console.log(this.taskList);

      this.selectedRoleId = ProId;
    });
  }

  CalculateDuration(numberofmonths: any): { startDate: Date; endDate: Date } {
    // Get the current UTC date
    const currentDate = new Date();

    // Calculate the end date based on the input value
    const endDate = new Date(
      currentDate.setUTCMonth(currentDate.getUTCMonth() + numberofmonths)
    );

    // Return both start and end dates

    return {
      startDate: new Date(), // current date and time
      endDate,
    };
  }

  durationoptionselected: boolean = false;
  durationcheck(m: any) {
    this.durationoptionselected = true;
    this.storewithduration = 0;
    const filteredOptions = this.DurationOption.filter(
      (duration: { id: any }) => {
        return duration.id == m;
      }
    );

    console.log('ok to yaha agya hai ');
    filteredOptions.forEach((option: any) => {
      console.log('ye option hai charge ki value ka ' + option.chargeDuration);
      this.selectedDuration = option;
      console.log('ye duration hai' + this.selectedDuration.duration);
    });
    //const duration = this.CalculateDuration(m);
    if (m == 0) {
      this.selectedDuration = 0;
      this.calculateTotalPrice();
    }

    const E_Date = new Date(this.D_Date);
    E_Date.setMonth(E_Date.getMonth() + this.selectedDuration.duration);
    this.E_Date =
      E_Date.toLocaleDateString('en-US', { year: 'numeric' }) +
      '-' +
      E_Date.toLocaleDateString('en-US', { month: '2-digit' }) +
      '-' +
      E_Date.toLocaleDateString('en-US', { day: '2-digit' }) +
      'T23:59:59.000Z';

    this.calculateTotalPrice();
  }

  selectedFeatures: any[] = [];
  totalPrice: any = 0;
  extraNOS: any = 0;
  additionalStorePrice: any = 0;
  totalPriceWithAdditionalStore: any = 0;
  selectedDuration: any = 0;
  individualStorePrice: any = 0;
  featureTotalPrice: any = 0;
  onetimeprice: any = 0;
  storewithduration: any = 0;
  totaloffeatureprice: any = 0;
  totalofonetimeprice: any = 0;
  totalofextrastoreprice: any = 0;
  calculateTotalPrice(): void {
    if (this.selectedDuration == 0) {
      this.totalPrice = 0;
      this.additionalStorePrice = 0;
      this.totalPriceWithAdditionalStore = 0;
      this.individualStorePrice = 0;
      this.storewithduration = 0;
      this.onetimeprice = 0;
      this.totaloffeatureprice = 0;
      this.totalofonetimeprice = 0;
      this.totalofextrastoreprice = 0;

      return;
    }
    if (this.selectedDuration.isTrial == true) {
      this.totalPrice = 0;
      this.additionalStorePrice = 0;
      this.totalPriceWithAdditionalStore = 0;
      this.individualStorePrice = 0;
      this.storewithduration = 0;
      this.onetimeprice = 0;
      this.totaloffeatureprice = 0;
      this.totalofonetimeprice = 0;
      this.totalofextrastoreprice = 0;

      return;
    }
    if (this.extraNOS < 0) {
      this.extraNOS = 0;
    }

    this.totalPrice = 0;
    this.additionalStorePrice = 0;
    this.totalPriceWithAdditionalStore = 0;
    this.individualStorePrice = 0;

    this.onetimeprice = 0;
    this.totaloffeatureprice = 0;
    this.totalofonetimeprice = 0;
    this.totalofextrastoreprice = 0;
    for (const module of this.taskList) {
      for (const feature of module.featureList) {
        if (feature.selected) {
          this.featureTotalPrice = feature.price;
          this.onetimeprice = feature.price_OneTime;

          console.log('onetimeprice : ' + this.onetimeprice);

          // Apply duration-based pricing for features
          // if (this.selectedDuration == 6) {
          //   this.featureTotalPrice *= 5; // Multiply by 5 for 6 months
          // } else if (this.selectedDuration == 12) {
          //   this.featureTotalPrice *= 10; // Multiply by 10 for 12 months
          // }

          this.featureTotalPrice *= this.selectedDuration.chargeDuration;

          this.totaloffeatureprice += this.featureTotalPrice;
          this.totalofonetimeprice += this.onetimeprice;
          this.featureTotalPrice += this.onetimeprice;
          this.totalPrice += this.featureTotalPrice;

          // if(this.selectedDuration == 0)
          // {
          //   this.totalPrice *= 0;
          //   this.totalofonetimeprice *= 0;
          //   this.totaloffeatureprice *= 0;
          // }
          // Calculate additional store price
          if (this.extraNOS >= 0) {
            this.additionalStorePrice +=
              this.extraNOS * feature.price_ExtraStore;
          } else {
            this.extraNOS = 0;
          }

          // Calculate individual additional store price with duration
          console.log(
            'before individual store price' + this.individualStorePrice
          );
          this.individualStorePrice = this.additionalStorePrice;
          // if (this.selectedDuration == 6) {
          //   console.log('before multiply 5 months ==============================='+this.individualStorePrice);
          //   this.individualStorePrice *= 5; // Multiply by 5 for 6 months
          //   console.log('after multiply 5 months'+this.individualStorePrice);
          // } else if (this.selectedDuration == 12) {
          //   console.log('before multiply 10 months'+this.individualStorePrice);
          //   this.individualStorePrice *= 10; // Multiply by 5 for 6 months
          //   console.log('after multiply 10 months'+this.individualStorePrice);
          // }

          this.individualStorePrice *= this.selectedDuration.chargeDuration;

          // if(this.selectedDuration.duration == 0)
          // {
          //   this.individualStorePrice *= 0;
          // }
          // Apply individual additional store price to feature
          this.featureTotalPrice += this.individualStorePrice;
          // Log individual feature total price
          console.log(
            `Feature: ${feature.FeatureName}, Individual Total Price: ${this.featureTotalPrice}`
          );
        }
        this.storewithduration = this.individualStorePrice;

        console.log('storewithduration : ' + this.storewithduration);
        console.log('additionalStorePrice  : ' + this.additionalStorePrice);
        // Calculate total price with additional store
        this.totalPriceWithAdditionalStore =
          this.totalPrice + this.storewithduration;
      }
    }
  }

  isextraStore: any = false;
  clientID: any;
  enablees() {
    if (this.isextraStore) {
      this.extraNOS = Math.max(1, this.extraNOS); // Set the value to 1 when the checkbox is checked
      this.calculateTotalPrice(); // Recalculate the total price
    } else {
      this.extraNOS = 0; // Set the value to zero when the checkbox is unchecked
      this.calculateTotalPrice();
    }
  }

  handleCheckboxChange(feature: any): void {
    if (feature.selected) {
      // If the feature is being selected, check for dependent features
      this.selectDependentFeature(feature.dependencyID);
    } else {
      // If the feature is being unselected, unselect its dependents
      this.deselectDependentFeature(feature.id);
    }

    // Calculate the total price regardless of dependency status
    this.calculateTotalPrice();
  }

  selectDependentFeature(dependencyId: number): void {
    for (const module of this.taskList) {
      for (const feature of module.featureList) {
        if (feature.id === dependencyId && !feature.selected) {
          // If the feature has Id equal to the specified DependencyID and is not already selected, select it automatically
          feature.selected = true;
          // Recursively check dependencies for the newly selected feature
          this.selectDependentFeature(feature.dependencyID);
        }
      }
    }
  }

  deselectDependentFeature(parentId: number): void {
    for (const module of this.taskList) {
      for (const feature of module.featureList) {
        if (feature.dependencyID === parentId && feature.selected) {
          // If the feature has DependencyID equal to the specified parentId and is selected, unselect it
          feature.selected = false;
          // Recursively unselect dependents for the newly unselected feature
          this.deselectDependentFeature(feature.id);
        }
      }
    }
  }

  Mainmsg: any;
  Momsg: any;
  Itemmsg: any;
  Issyncmsg: any;
  ButtonLoading: boolean = false;
  // other methods and properties
  updateAllTasks() {

    this.ButtonLoading = true;
    const productFeatureList: any[] = [];

    const requestData: {
      isOldClient: boolean;
      license_Code: any;
      date_TrialEnd: any;
      isNFR: boolean;
      extraStores: string;
      IsRMHCentral: boolean;
      isTrial: boolean;
      owner_ID: number;
      partner_ID: number;
      productList: any[];
      user_ID: any;
      isBillToClient: boolean;
    } = {
      isOldClient: false,
      license_Code: '.',
      extraStores: this.extraNOS,
      isBillToClient: false,
      isNFR: true,
      isTrial: this.selectedDuration.isTrial,
      owner_ID: JSON.parse(localStorage.getItem('UserInfo')?.toString() || '{}')
        ?.id,
      partner_ID: JSON.parse(
        localStorage.getItem('UserInfo')?.toString() || '{}'
      )?.partner_Id,

      user_ID: this.clientID,
      productList: [],

      date_TrialEnd: this.D_Date,

      IsRMHCentral: this.isextraStore,
    };

    for (const module of this.taskList) {
      for (const feature of module.featureList) {
        if (feature.selected) {
          productFeatureList.push(feature.id);
        }
      }
    }
    if (this.selectedDuration.isTrial) {
      requestData.date_TrialEnd = this.E_Date;
    }

    requestData['productList'] = [
      {
        productID: this.proId,
        date_Start: this.D_Date, // Example start date
        isProRateApply: false, // Modify as needed
        licenseDurationID: this.selectedDuration.id, // Example duration ID
        featureList: productFeatureList,
      },
    ];


    if (productFeatureList.length == 0) {
      alert('Please select atleast one feature');
      this.ButtonLoading = false;
      return;
    }

    console.log(requestData);

    if (requestData.productList.length > 0) {
      console.log(requestData);

      this.ClientlicensesService.InsertLicense(requestData).subscribe(
        (response: any) => {
          console.log(response);

          if (response.apiStatus.isSuccess == false) {
            // const openModalButton1 = document.getElementById('openModalButtonff');
            // if (openModalButton1) {
            //   openModalButton1.click();
            // }

            alert(response.apiStatus.message);
            this.Mainmsg = 'Incomplete data';
            this.ClearAll();
            // this.router.navigate(['/clientpage']);
            this.toggleModal();
            this.ngOnInit();
            setTimeout(() => {
              const options = {
                title: `License Creation Failed`,
                delay: 3000,
                color: 'danger',
                autohide: true,
                description: this.Mainmsg,
                status: false,
              };
              this.ToastService.showToast(options);
            }, 1000);
            this.ButtonLoading = false;
          }

          if (response.apiStatus.isSuccess) {
            this.ClearAll();
            // this.router
            //   .navigate(['/clientpage'], { queryParams: { key: 'PaymentHistory' } })
            //   .then(() => {
            setTimeout(() => {
              const options = {
                title: `Success`,
                delay: 3000,
                color: 'success',
                autohide: true,
                description: response.apiStatus.message,
                status: true,
              };
              this.ToastService.showToast(options);
            }, 1000);
            this.ButtonLoading = false;

            // });
            this.toggleModal();
            this.ngOnInit();

          }

          // this.router.navigate(['/clientpage']);
          this.msg = response.message;

          setTimeout(() => {
            this.msg = null;
          }, 5000);
          this.ngOnInit();
        }
      );
    }
  }

  ClearAll() {
    this.IsAllowedCentral = false;
    this.taskList = '';
    this.selectedRoleId = '';
    this.extraNOS = 0;
    this.totalPrice = 0;
    this.additionalStorePrice = 0;
    this.totalPriceWithAdditionalStore = 0;
    this.selectedDuration = 0;
    this.clientID = '';
    this.isextraStore = false;
    this.individualStorePrice = 0;
    this.featureTotalPrice = 0;
    this.storewithduration = 0;
    this.Momsg = '';
    //this.Mainmsg = '';
    this.durationoptionselected = false;
    this.IsProductSelected = false;
    this.DurationOption = '';
  }
  NewProduction() {
    this.Mainmsg = '';
    //this.router.navigate(['/Licenses/CreateNFRLicense']);
  }


  ModalVisible: boolean = false;
  toggleModal() {

    if (this.ModalVisible) {

    }
    this.ModalVisible = !this.ModalVisible;
  }
  UserData: any;
  IsAdmin: boolean = false;
  ngOnInit(): void {
    let userInfo = JSON.parse(localStorage.getItem('UserInfo') || '{}');
    if (userInfo.userType_Id == 3) {
      this.IsAdmin = true;
    }
    if (!this.baseService.CheckPermissions('CreateLicenses')) {
      this.router.navigate(['/dashboard']);
    }
    // this.UsersService.selectedClientData.subscribe((data) => {
    //   this.UserData = data;
    //   console.log(
    //     '🚀 > CreatelicenseComponent > ngOnInit > this.UserData',
    //     this.UserData
    //   );
    //   this.GetProductList(this.UserData.id);
    //   this.getLicenses(this.UserData.id);

    // });
    this.UsersService.getByIdUser(JSON.parse(localStorage.getItem('UserInfo') || '{}').partner_Id).subscribe({
      next: (res: any) => {
        this.UserData = res.data;
        console.log('UserData');
        console.log(this.UserData);
        this.GetProductList(this.UserData?.id);
        this.getLicenses(this.UserData.id);

      },
      error: (error) => {
        console.error(error);
      },
    });


    this.partnerpercentage = JSON.parse(
      localStorage.getItem('packages') || '{}'
    )[0]?.discountPercent;

    this.serviceItemDiscount = JSON.parse(
      localStorage.getItem('packages') || '{}'
    )[0]?.serviceDiscountPercent;

    console.log('Partner Percentage: ' + this.partnerpercentage);
    console.log('Partner Percentage Service: ' + this.serviceItemDiscount);
  }

  //--------------------------------------------------------------------------------------------------------------------------------------------------------

  LicensesData: any;

  LicensesColumns: any = [
    {
      key: 'productName',
      label: 'Product Name',
    },
    {
      key: 'date_Start',
      label: 'Date Created',
    },
    {
      key: 'date_Expire',
      label: 'Expiry Date',
    },
    {
      key: 'isActive',
      label: 'Status',
    },
    // {
    //   key: 'Actions',
    //   label: '',
    //   _style: { width: '5%' },
    //   filter: false,
    //   sorter: false,
    // },
  ];

  ShowLicenseDetails(item: any) {
    console.log(
      this.LicensesDataToShow
    );
    console.log('🚀 > ClientpageComponent > ShowLicenseDetails > item:', item);
    this.licenseData = item;
    this.toggleModalLicenseDetails();
  }

  LicensesDataToShow: any;
  licenseData: any;
  getLicenses(id: any) {
    this.Loading = true;
    var body = {
      id: id,
      type: 'P',
    };
    console.log("🚀 > getLicenses > body:", body);

    this.UsersService.getAllLicensesByPersonID(body).subscribe({
      next: (res: any) => {

        console.log("🚀 > this.UsersService.getAllLicensesByPersonID > res:", res)

        this.LicensesData = res?.data?.filter((item: any) => item.license_Products[0].isNFR == true);
        // this.LicensesDataToShow = this.LicensesData?.map((item: any) => {
        //   return {
        //     ...item,
        //     productName: item.license_Products[0].productName,
        //     date_Expire: item.license_Products[0].date_Expire,
        //     date_Start: item.license_Products[0].date_Start,
        //     isActive: item.license_Products[0].isActive,
        //     // extraNoOfStores: item.license_Products[0].extraNoOfStores,
        //     // isRMHCentral: item.licenseDetails[0].isRMHCentral,
        //   };
        // });
        this.LicensesDataToShow = this.LicensesData[0]?.license_Products;
        console.log(
          this.LicensesDataToShow
        );
        this.Loading = false;
      },
      error: (error) => {
        console.error(error);
        this.Loading = false;
      },
    });
  }

  ModalVisibleLicenseDetails: boolean = false;
  toggleModalLicenseDetails() {
    if (this.ModalVisibleLicenseDetails) {

    }
    this.ModalVisibleLicenseDetails = !this.ModalVisibleLicenseDetails;
  }
  details_visible = Object.create({});
  toggleDetails(item: any) {
    this.details_visible[item] = !this.details_visible[item];
  }




}
